import React, { Component } from 'react';

import { Layout } from '@eventbrite/eds-layout';
import { Icon } from '@eventbrite/eds-icon';
import { ArrowRightChunky } from '@eventbrite/eds-iconography';

import ProjectCard from '../components/ProjectCard';

import { projects, sdks, books } from '../constants';

import './ossLandingPage.scss';

const Header = () => (
    <div className="open-source__header eds-bg-color--grey-800">
        <div className="open-source__header-wrapper eds-align--center">
            <div className="open-source__header-container">
                <h1 className="open-source__header-title eds-text-hxl">
                    <span className="eventbrite eds-l-mar-bot-4">We Love</span>
                    <br />
                    <span className="open-source">Open Source</span>
                </h1>
                <h3 className="open-source__header-subtitle eds-text-hs">
                    We want to give back and create a community around our open
                    source projects
                </h3>
            </div>
        </div>
    </div>
);

const BlogBanner = () => (
    <div className="engineering-blog-banner engineering-blog-banner--blog">
        <a
            href="https://www.eventbrite.com/engineering/"
            target="_blank"
            rel="noopener noreferrer"
            className="engineering-blog-banner__link eds-l-pad-vert-8 eds-l-pad-hor-4"
        >
            <h3 className="eds-text-hm bld-text eds-text-color--white">
                Eventbrite Engineering
            </h3>
            <p className="eds-text-bl eds-align--left eds-text-color--white eds-l-pad-top-4">
                Read our latests posts in the engineering blog of Eventbrite.
            </p>
            <div className="engineering-blog-banner__cta eds-align--center-vertical eds-l-pad-top-5">
                <p className="engineering-blog-banner__cta-text eds-text-bl bold-text eds-text-color--ui-orange">
                    Read the blog
                </p>
                <span>
                    <Icon
                        type={<ArrowRightChunky />}
                        size="xsmall"
                        color="ui-orange"
                    />
                </span>
            </div>
        </a>
    </div>
);

const CareersBanner = () => (
    <div className="engineering-blog-banner engineering-blog-banner--careers">
        <a
            href="https://www.eventbritecareers.com/home?lever-origin=applied&lever-source%5B%5D=OSSLandingPage"
            target="_blank"
            rel="noopener noreferrer"
            className="engineering-blog-banner__link eds-l-pad-vert-8 eds-l-pad-hor-4"
        >
            <h3 className="eds-text-hm bld-text eds-text-color--ui-900">
                We are hiring!
            </h3>
            <p className="eds-text-bl eds-align--left eds-text-color--ui-900 eds-l-pad-top-4">
                At Eventbrite, we make work play. We tackle complex challenges,
                work hard, high-five and celebrate.
            </p>
            <div className="engineering-blog-banner__cta eds-align--center-vertical eds-l-pad-top-5">
                <p className="engineering-blog-banner__cta-text eds-text-bl bold-text eds-text-color--ui-orange">
                    Join our team
                </p>
                <span>
                    <Icon
                        type={<ArrowRightChunky />}
                        size="xsmall"
                        color="ui-orange"
                    />
                </span>
            </div>
        </a>
    </div>
);

const getProjects = () => (
    <div className="open-source__projects-container">
        <ul className="open-source__project-list">
            {projects.map(
                ({ id, description, name, technology, thumbnail, url }) => {
                    return (
                        <li
                            className="
                            open-source__project
                            eds-g-cell
                            eds-g-cell--has-overflow
                            eds-g-cell-12-12
                            eds-g-cell-sw-6-12
                            eds-g-cell-mn-4-12
                            eds-g-cell-lg-4-12
                        "
                            key={id}
                        >
                            <ProjectCard
                                description={description}
                                name={name}
                                technology={technology}
                                thumbnail={thumbnail}
                                url={url}
                            />
                        </li>
                    );
                },
            )}
        </ul>
    </div>
);

const getSDKs = () => (
    <div className="open-source__sdks-container">
        <ul className="open-source__sdk-list">
            {sdks.map(({ id, name, description, url, technology }) => {
                return (
                    <li
                        className="
                            open-source__sdk
                            eds-g-cell
                            eds-g-cell--has-overflow
                            eds-g-cell-12-12
                            eds-g-cell-sw-6-12
                            eds-g-cell-mn-4-12
                            eds-g-cell-lg-4-12
                        "
                        key={id}
                    >
                        <ProjectCard
                            name={name}
                            description={description}
                            url={url}
                            technology={technology}
                        />
                    </li>
                );
            })}
        </ul>
    </div>
);

const getBooks = () => (
    <div className="open-source__books-container">
        <ul className="open-source__books-list">
            {books.map(
                ({
                    id,
                    name,
                    author,
                    description,
                    url,
                    thumbnail,
                    website,
                }) => {
                    return (
                        <li
                            className="
                        open-source__book
                        eds-g-cell
                        eds-g-cell--has-overflow
                        eds-g-cell-12-12
                        eds-g-cell-sw-6-12
                        eds-g-cell-mn-4-12
                        eds-g-cell-lg-4-12
                    "
                            key={id}
                        >
                            <ProjectCard
                                name={name}
                                description={description}
                                url={url}
                                thumbnail={thumbnail}
                                subheader={author}
                                subheaderLink={website}
                            />
                        </li>
                    );
                },
            )}
        </ul>
    </div>
);

export class OSSLandingPage extends Component {
    render = () => {
        const header = <Header />;

        return (
            <Layout
                hasHorizontalGutters={true}
                header={header}
                peakSize="small"
                maxWidth="large"
            >
                <div className="eds-g-grid">
                    <div className="open-source__projects">
                        <div className="eds-g-cell eds-g-cell-12-12">
                            <h2 className="eds-text-hm open-source__projects-title">
                                Our Projects
                            </h2>
                        </div>
                        <div className="eds-g-cell eds-g-cell-12-12">
                            {getProjects()}
                        </div>
                    </div>
                    <div className="open-source__banners">
                        <BlogBanner />
                        <CareersBanner />
                    </div>
                    <div className="open-source__books">
                        <div className="eds-g-cell eds-g-cell-12-12">
                            <h2 className="eds-text-hm open-source__projects-title">
                                Books by our Engineers
                            </h2>
                        </div>
                        <div className="eds-g-cell eds-g-cell-12-12">
                            {getBooks()}
                        </div>
                    </div>
                    <div className="open-source__sdks">
                        <div className="eds-g-cell eds-g-cell-12-12">
                            <h2 className="eds-text-hm open-source__projects-title">
                                Our SDKs
                            </h2>
                        </div>
                        <div className="eds-g-cell eds-g-cell-12-12">
                            {getSDKs()}
                        </div>
                    </div>
                </div>
            </Layout>
        );
    };
}
